import useSWR from "swr";
import { type QuizDetail } from "../types";
import { simpleFetcher } from "../fetcher";

/** A single quiz with its questions and answer options, for taking or editing. */
export function useQuizDetail(id: number) {
  return useSWR<QuizDetail, Error>(`/api/v2/quizzes/${id}`, simpleFetcher);
}
